import { useSnapshot } from 'valtio';

import { FileUploader } from '@cartwhl/ui/feature/FileUploader';

import { characterPickerStore } from 'stores';

import { ACCEPTED_FILE_TYPES, MAX_FILE_SIZE } from '../constants';

export default function CharacterUploader() {
  const { upload } = useSnapshot(characterPickerStore.state);

  return (
    <FileUploader
      fileContent="Character"
      accept={{
        'application/octet-stream': ACCEPTED_FILE_TYPES,
      }}
      maxFileSize={MAX_FILE_SIZE}
      upload={upload}
      onDrop={(file) => characterPickerStore.beginCharacterUpload(file, false)}
      onRemove={() => characterPickerStore.removeUpload()}
      onCancel={(uploadId: string) =>
        characterPickerStore.deleteCustomCharacter(uploadId, true)
      }
      cancelable
    />
  );
}
